import { FieldError } from '../../../types/common/form';

export const convertFieldError = (err: { [fieldName: string]: { errors: FieldError[] } }) =>
  Object.values(err).flatMap(({ errors }) => errors);
